"use client"

import { useEffect } from "react"
import { ErrorState } from "@/components/error-state"

/** 라우트 세그먼트 에러 경계 — 루트 레이아웃(테마·폰트)은 유지된 채 본문만 교체. */
export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    console.error(error)
  }, [error])
  const message = error.message && error.message.length < 300 ? error.message : "예상하지 못한 오류가 발생했습니다."
  return (
    <main className="flex min-h-screen flex-col bg-canvas">
      <div className="kiwoom-strip" />
      <ErrorState
        title="페이지를 표시할 수 없습니다"
        message={error.digest ? `${message}\n(참조: ${error.digest})` : message}
        retry={reset}
      />
    </main>
  )
}
